import { Mitarbeiter } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class Dokumente {
  constructor({
    id,
    mitarbeiter,
    erstellungsDatum,
    name,
  }: {
    id: string;
    mitarbeiter: Mitarbeiter;
    name: string;
    erstellungsDatum: dayjs.Dayjs;
  }) {
    this.id = id;
    this.erstellungsDatum = erstellungsDatum;
    this.name = name;
    this.mitarbeiter = mitarbeiter;
  }

  id: string;
  name: string;
  erstellungsDatum: dayjs.Dayjs;
  mitarbeiter: Mitarbeiter;
}
